import { css } from "@emotion/react";

export const container = css`
    flex-grow: 1;
    width: 100%;
    overflow-y: visible;
`;